import { Frame } from '../components/Frame';
import { KrabenMark } from '../components/KrabenMark';
import { abandonHandoff } from '../lib/account';
import { STUCK } from '../data/keep-copy';
import { track } from '../analytics';
import { useViewed } from '../lib/viewed';

/**
 * A handoff link the backend could not redeem just now (lib/account.ts). The
 * url still carries the code, so trying again is a reload; starting fresh drops
 * it and opens this browser as somebody new.
 */
export function HandoffStuck() {
  useViewed('handoff_stuck');
  return (
    <Frame>
      <div className="stack" style={{ alignItems: 'center', textAlign: 'center', paddingTop: 40 }}>
        <KrabenMark size={120} />
        <h1>{STUCK.title}</h1>
        <p className="why">{STUCK.why}</p>
        <button className="btn" onClick={() => { track('handoff_retry'); window.location.reload(); }}>{STUCK.retry}</button>
        <button className="btn ghost" onClick={() => { track('handoff_abandoned'); abandonHandoff(); }}>{STUCK.fresh}</button>
      </div>
    </Frame>
  );
}
